import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import QrcodeOutlinedSvg from "@ant-design/icons-svg/es/asn/QrcodeOutlined";
import AntdIcon from "../components/AntdIcon";
var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QrcodeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  QrcodeOutlined.displayName = 'QrcodeOutlined';
}
export default /*#__PURE__*/React.forwardRef(QrcodeOutlined);